import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Logger } from 'src/services/logger.service';

import { EnDownloadTarget } from 'src/enums/EnDownloadTarget';

export const DownloadGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean | UrlTree> => {
  const router = inject(Router);

  const target: EnDownloadTarget | undefined = route.queryParams['target'];
  const token: string | undefined = route.queryParams['token'];

  if (target !== undefined && token) {
    return true;
  } else {
    Logger.logError(
      `ERROR DownloadGuard: Cannot find needed query parameters.`
    );
    return router.createUrlTree(['']);
  }
};
